module.exports = __webpack_public_path__ + "img/dialog_name.72a140bd.svg";